import * as React from 'react';
import { useRef, useState } from 'react';
import type { TextInput } from 'react-native';
import {
    BodyMediumRegular,
    LabelRegular,
    StyledBodyMediumRegularInputNoOutline,
    View,
    XStack,
    YStack,
} from 'smoothie';

import PaycheckRoutingCard from '../../paycheck-routing/common/PaycheckRoutingCard';

interface RuleEditorPercentageProps {
    amount?: number;
    updateAmount: (amount: number) => void;
    label: string;
}

const RuleEditorPercentage = ({
    amount,
    updateAmount,
    label,
}: RuleEditorPercentageProps) => {
    const [amountWidth, setAmountWidth] = useState(0);

    const inputRef = useRef<TextInput | null>(null);

    return (
        <YStack gap={8}>
            {/* hidden element to help determine input width so it only stretches as far as its content */}
            <View
                position="absolute"
                opacity={0}
                onLayout={(e) => {
                    setAmountWidth(e.nativeEvent.layout.width);
                }}
            >
                <BodyMediumRegular>{amount}</BodyMediumRegular>
            </View>

            <LabelRegular marginLeft={8} color="$gray1100">
                {label}
            </LabelRegular>
            <PaycheckRoutingCard
                onPress={() => {
                    inputRef.current?.focus();
                }}
            >
                <XStack alignItems="center">
                    <StyledBodyMediumRegularInputNoOutline
                        ref={inputRef}
                        keyboardType="number-pad"
                        padding={0}
                        value={(amount != null && amount > 0
                            ? amount
                            : ''
                        ).toString()}
                        onChangeText={(incomingValue) => {
                            const numberValue = parseInt(incomingValue, 10);
                            const newValue =
                                Number.isNaN(numberValue) || numberValue > 100
                                    ? 0
                                    : numberValue;
                            updateAmount(newValue);
                        }}
                        returnKeyType="done"
                        height={22}
                        width={amountWidth}
                    />
                    <BodyMediumRegular>%</BodyMediumRegular>
                </XStack>
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default RuleEditorPercentage;
